module.exports = __webpack_public_path__ + "img/active-brands-banner.9fa60e10.jpg";